export function initVideoModule(): void {
  const videos = document.querySelectorAll(
    '.feature-image-wrapper .product-single__photo--has-video video'
  );

  if (!window.IntersectionObserver) {
    return;
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (!entry.intersectionRatio) {
          const video = entry.target;

          if (!(video instanceof HTMLVideoElement)) {
            return;
          }

          video.pause();
          video.currentTime = 0;
        }
      });
    },
    {
      root: document.body,
    }
  );

  videos.forEach((video) => {
    observer.observe(video);
  });
}
